import {translations} from 'presentation/translations-new';
import {CategoryFilterExamsEnum} from './categoryFilterExamsEnum';

const {filter} = translations['pt-br'].privateFlow.myHospitalization.exams;

export const filters = [
	{
		label: filter.all,
		category: CategoryFilterExamsEnum.ALL,
	},
	{
		label: filter.laboratory,
		category: CategoryFilterExamsEnum.LAB,
	},
	{
		label: filter.image,
		category: CategoryFilterExamsEnum.IMAGE,
	},
];
